import { render, staticRenderFns } from "./YearReportTable.vue?vue&type=template&id=22b91c90"
import script from "./YearReportTable.vue?vue&type=script&lang=js"
export * from "./YearReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports